export default __webpack_public_path__ + "static/media/640_store01-es-web.85930f60.png";